import React from 'react';
import { Box } from '@mui/material';
import { gray100 } from '../../constants/colors';
import ForgetPasswordCard from '../uiParts/ForgetPasswordCard';
import Header from '../uiParts/Header';
import MetaTitle from '../utils/MetaTitle';

const styles = {
  page: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    '@media (max-width: 600px)': {
      flexDirection: 'column',
      paddingTop: '0',
      justifyContent: 'flex-start',
    },
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingTop: '289px',
    backgroundColor: '#FBFBFB',
    height: '100vh',
    width: '-webkit-fill-available',
    '@media (max-width: 600px)': {
      height: '100%',
      alignItems: 'flex-start',
      paddingTop: '50%',
    },
  },
  header: {
    color: 'white',
    textAlign: 'left',
    backgroundColor: gray100,
    width: '100vw',
    height: '64px',
    '@media (max-width: 600px)': {
      width: '100%',
      height: '48px',
    },
  },
};

const ForgetPassword: React.FC = () => {
  return (
    <>
      <MetaTitle />
      <Box sx={styles.page}>
        <Header />
        <Box sx={styles.container}>
          <ForgetPasswordCard />
        </Box>
      </Box>
    </>
  );
};

export default ForgetPassword;
